import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import styles from "./UseCasesSection.module.css";
import ScrollReveal from "../components/ScrollReveal";
import {
  FaHardHat,
  FaRoad,
  FaSearch,
  FaIndustry,
  FaMapMarkedAlt,
} from "react-icons/fa";

const useCases = [
  {
    iconKey: "works",
    Icon: FaHardHat,
    accentColor: "#F59E0B",
    titleKey: "useCases.works.title",
    descriptionKey: "useCases.works.description"
  },
  {
    iconKey: "infrastructure",
    Icon: FaRoad,
    accentColor: "#10B981",
    titleKey: "useCases.infrastructure.title",
    descriptionKey: "useCases.infrastructure.description"
  },
  {
    iconKey: "inspections",
    Icon: FaSearch,
    accentColor: "#8B5CF6",
    titleKey: "useCases.inspections.title",
    descriptionKey: "useCases.inspections.description"
  },
  {
    iconKey: "industrial",
    Icon: FaIndustry,
    accentColor: "#EF4444",
    titleKey: "useCases.industrial.title",
    descriptionKey: "useCases.industrial.description"
  },
  {
    iconKey: "terrain",
    Icon: FaMapMarkedAlt,
    accentColor: "#0EA5E9",
    titleKey: "useCases.terrain.title",
    descriptionKey: "useCases.terrain.description"
  }
];

const UseCaseCard = ({ item, delay }) => {
  const { Icon, accentColor } = item;
  return (
    <ScrollReveal delay={delay}>
      <div
        className={styles.card}
        style={{ '--accent': accentColor }}
      >
        <div className={styles.cardAccentBar} />
        <div className={styles.cardIcon}>
          <Icon size={22} aria-hidden="true" />
        </div>
        <h3 className={styles.cardTitle}>
          <FormattedMessage id={item.titleKey} />
        </h3>
        <p className={styles.cardDescription}>
          <FormattedMessage id={item.descriptionKey} />
        </p>
      </div>
    </ScrollReveal>
  );
};

const UseCasesSection = () => {
  return (
    <section id="casos-uso" className={styles.useCases}>
      <div className={styles.container}>
        <ScrollReveal>
          <div className={styles.sectionLabel}>
            <span className={styles.labelLine} />
            <FormattedMessage id="useCases.label" defaultMessage="Casos de uso" />
            <span className={styles.labelLine} />
          </div>
          <h2 className={styles.sectionTitle}>
            <FormattedMessage id="useCases.title" />
          </h2>
          <p className={styles.sectionSubtitle}>
            <FormattedMessage id="useCases.subtitle" />
          </p>
        </ScrollReveal>

        <div className={styles.grid}>
          {useCases.map((item, i) => (
            <UseCaseCard key={item.iconKey} item={item} delay={i * 60} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default injectIntl(UseCasesSection);
